<template>
	<div class="my-scrollbar-content">
		<ul>
			<li class="span-list" v-for="(item,index) in myMusic"  v-if="!item.isShow" @click.stop="downloadBodang(item,index)">
				<div style="display: flex;align-items: center;">
					<span v-if="CurrentPlayback.name!=item.name" class="pOYdmm9IN1vgZBmXNMdb">{{index+1}}</span>
					<div style="margin-right: .04rem;" v-else>
						<svg-icon  className="download"  icon-class="icon_yy_yy--svgSprite:all"  />
					</div>
					<!-- <span class="Yq318izr1SbfjTmSZsB_">{{item.name}}</span> -->
					<span class="Yq318izr1SbfjTmSZsB_" :class="{
						XYr17inGDJI2d2opY3T0:CurrentPlayback.name==item.name
					}">{{item.name}}</span>
					<span class="sdkJDzoSWd1CqOy2h48_">{{item.size}}</span>
				</div>
				<div style="display: flex;align-items: center;">
					<svg-icon  className="download"  icon-class="comm_icon_gou--svgSprite:all"  />
					<p @click.stop="deleteFun(item,index)" style="display: flex;align-items: center;">
						<svg-icon  className="delete"   icon-class="comm_icon_del--svgSprite:all"  />
					</p>
				</div>
			</li>
		</ul>
	</div>
</template>

<script>
	import { mapState } from 'vuex';
	export default {
		computed:{
			...mapState(['songSheetList','CurrentPlayback'])
		},
		props:{
			PlayList:{
				type:[Array,Object,String],
				required:[],
			},
			myMusicList:{
				type:[Array,Object,String],
				required:[],
			},
			myMusic:{
				type:[Array,Object,String],
				required:[],
			},
			
		},
		data() {
			return {
			}
		},
		created(){
		},
		methods: {
			deleteFun(item,index){
				this.$emit('onDelete',item,index)
			},
			downloadBodang(e,index){
				this.download(e,index)
				this.$emit("xiaAzibaofan",e,index)
			},
			download(e) {
				if(this.myMusicList.indexOf(e.name)==-1){
					e.isdownload=this.myMusicList.length
					this.myMusicList.push(e.name)
					localStorage.setItem('myMusicList',this.myMusicList)
				}
			}
		},
	}
</script>

<style scoped>
	.my-scrollbar-content .span-list {
		font-size: .2rem;
		height: .8rem;
		padding: 0;
		    color: var(--cms-text-color-primary);
		border-bottom: thin solid var(--cms-background-color-secondary);
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.pOYdmm9IN1vgZBmXNMdb {
	    color: var(--cms-text-color-secondary);
	    margin-right: .1rem;
	}
	.Yq318izr1SbfjTmSZsB_ {
	    margin-right: .1rem;
	    max-width: 3.8rem;
	    overflow: hidden;
	    text-overflow: ellipsis;
		display: inline-block;
	    white-space: nowrap;
	}
		.sdkJDzoSWd1CqOy2h48_ {
	    color: var(--cms-text-color-secondary) !important;
	    font-size: .16rem;
	}
	.XYr17inGDJI2d2opY3T0{
		    color: var(--cms-primary-color) !important;
	}
		
	.span-list div .delete,.span-list div .download{
		    color: var(--cms-primary-color);
			width: .3rem;
			height: .3rem;
	}
	.span-list div .delete{
		    color: var(--theme-secondary-color-error);
			margin-left: .25rem;
	}
</style>
